import React from "react";
import {Route, Routes, Navigate} from "react-router-dom";
import {locations} from "../../Utilities/Location";
import {DashboardContainer} from "../../Containers/Dashboard/";
import {LandingContainer} from "../../Containers/Landing/";
import {
    LoanLibraryCatalogContainer,
    LoanLibraryCatalogWhatsNewContainer,
    LoanLibraryQueueContainer,
    LoanLibraryHistoryContainer,
    LoanLibraryCatalogItemContainer,
    LibraryVendorContainer,
    ManufacturerContainer,
    OwnCatalogContainer,
    OwnCatalogItemContainer,
    OwnCatalogWhatsNewContainer,
    OwnQueueContainer,
    ShippingLocationAddContainer,
} from "../../Containers/Library";
import {NotFoundContainer} from "../../Containers/NotFound/";
import {PageSetup} from "../../Containers/PageSetup/";
import {PasswordRequestContainer, PasswordUpdateContainer} from "../../Containers/Password";
import {ReportsContainer} from "../../Containers/Reports";
import {SignInContainer} from "../../Containers/SignIn/";
import {SignOutContainer} from "../../Containers/SignOut/";
import {UserApprovalContainer, UserProfileContainer, UserRegisterContainer} from "../../Containers/User/";
import {
    LoanLibraryLoanManagementContainer,
    OwnLoanManagementContainer,
    OwnLoanHistoryContainer,
} from "../../Containers/Loan";
import {DymoPrintLabelContainer} from "../../Containers/DymoPrinting/DymoPrintLabelContainer";

const SiteRoutes = () => {

    const Dashboard = <PageSetup component={DashboardContainer} path={locations.DASHBOARD.path}/>;
    const LandingPage = <PageSetup component={LandingContainer} path={locations.LANDING.path}/>;

    //Own Library
    const OwnCatalogItemPage = <PageSetup component={OwnCatalogItemContainer} path={locations.OWN_CATALOG_ITEM.path}
                                          showOwnCatalogLink/>;
    const OwnCatalogPage = <PageSetup component={OwnCatalogContainer} path={locations.OWN_CATALOG.path}/>;
    const OwnQueuePage = <PageSetup component={OwnQueueContainer} path={locations.OWN_QUEUE.path}
                                    showOwnCatalogLink/>;
    const OwnWhatsNewPage = <PageSetup component={OwnCatalogWhatsNewContainer} path={locations.OWN_WHATS_NEW.path}
                                       showOwnCatalogLink/>;
    const OwnLoanProcessingPage = <PageSetup component={OwnLoanManagementContainer} path={locations.OWN_LOAN_MANAGEMENT.path}/>;
    const OwnLoanHistoryPage = <PageSetup component={OwnLoanHistoryContainer} path={locations.OWN_LOAN_HISTORY.path}
                                         showOwnCatalogLink/>;

                                         
    //Loan Library
    const LoanLibraryLoanManagementPage = <PageSetup component={LoanLibraryLoanManagementContainer} path={locations.LOAN_LIBRARY_LOAN_MANAGEMENT.path}/>;
    const LoanLibraryCatalogPage = <PageSetup component={LoanLibraryCatalogContainer} path={locations.LOAN_LIBRARY_CATALOG.path}
    />;
    const LoanLibraryCatalogItemPage = <PageSetup component={LoanLibraryCatalogItemContainer} path={locations.LOAN_LIBRARY_CATALOG_ITEM.path}
                                                  showLoanLibraryCatalogLink/>;
    const LoanLibraryQueuePage = <PageSetup component={LoanLibraryQueueContainer} path={locations.LOAN_LIBRARY_QUEUE.path}
                                            showLoanLibraryCatalogLink/>;
    const LoanLibraryHistoryPage = <PageSetup component={LoanLibraryHistoryContainer} path={locations.LOAN_LIBRARY_HISTORY.path}
                                              showLoanLibraryCatalogLink/>;
    const LoanLibraryManufacturerPage = <PageSetup component={ManufacturerContainer} path={locations.LOAN_LIBRARY_MANUFACTURER.path}
                                               />;
    const LibraryVendorPage = <PageSetup component={LibraryVendorContainer} path={locations.LIBRARY_VENDOR.path}
                                         />;
    const LoanLibraryWhatsNewPage = <PageSetup component={LoanLibraryCatalogWhatsNewContainer} path={locations.LOAN_LIBRARY_WHATS_NEW.path}
                                               showLoanLibraryCatalogLink/>;

    //AUTHENTICATION
    const RegistrationPage = <PageSetup component={UserRegisterContainer} path={locations.REGISTER.path}/>;
    const SignInPage = <PageSetup component={SignInContainer} path={locations.SIGN_IN.path}/>;
    const SignOutPage = <PageSetup component={SignOutContainer} path={locations.SIGN_OUT.path}/>;
    const UpdatePasswordPage = <PageSetup component={PasswordUpdateContainer} path={locations.UPDATE_PASSWORD.path}/>;
    const ForgotPasswordPage = <PageSetup component={PasswordRequestContainer} path={locations.FORGOT_PASSWORD.path}/>;

    //Shipping Location
    const ShippingLocationAddPage = <PageSetup component={ShippingLocationAddContainer} path={locations.SHIPPING_LOCATION_ADD.path} />;

    //USER
    const UserApprovalPage = <PageSetup component={UserApprovalContainer} path={locations.USER_MANAGEMENT.path}
    />;
    const UserProfilePage = <PageSetup component={UserProfileContainer}
                                       path={locations.USER_PROFILE.path}/>;
    //REPORTS
    const ReportsPage = <PageSetup component={ReportsContainer} path={locations.REPORTS.path}/>;

    const DymoPrintLabelPage = <PageSetup component={DymoPrintLabelContainer} path={locations.DYMO_PRINT_LABEL.path}
                                          showSignOutLink showLoanLibraryCatalogLink/>;

    // *********************** LAST: NOT FOUND ***********************
    const NotFoundPage = <PageSetup component={NotFoundContainer} path={locations.NOT_FOUND.path}/>;

    return (
        <Routes>
            <Route path={locations.SIGN_IN.path} element={SignInPage}/>
            <Route path={locations.SIGN_OUT.path} element={SignOutPage}/>
            <Route path={locations.REGISTER.path} element={RegistrationPage}/>
            <Route path={locations.LANDING.path} element={LandingPage}/>

            {/* Loan Library */}
            <Route path={locations.LOAN_LIBRARY_CATALOG.path} element={LoanLibraryCatalogPage}/>
            <Route path={locations.LOAN_LIBRARY_CATALOG_ITEM.path} element={LoanLibraryCatalogItemPage}/>
            <Route path={locations.LOAN_LIBRARY_QUEUE.path} element={LoanLibraryQueuePage}/>
            <Route path={locations.LOAN_LIBRARY_HISTORY.path} element={LoanLibraryHistoryPage}/>
            <Route path={locations.LOAN_LIBRARY_MANUFACTURER.path} element={LoanLibraryManufacturerPage}/>
            <Route path={locations.LIBRARY_VENDOR.path} element={LibraryVendorPage}/>
            <Route path={locations.LOAN_LIBRARY_WHATS_NEW.path} element={LoanLibraryWhatsNewPage}/>
            <Route path={locations.LOAN_LIBRARY_LOAN_MANAGEMENT.path} element={LoanLibraryLoanManagementPage}/>

            {/* Own */}
            <Route path={locations.OWN_CATALOG_ITEM.path} element={OwnCatalogItemPage}/>
            <Route path={locations.OWN_CATALOG.path} element={OwnCatalogPage}/>
            <Route path={locations.OWN_QUEUE.path} element={OwnQueuePage}/>
            <Route path={locations.OWN_WHATS_NEW.path} element={OwnWhatsNewPage}/>

            {/* Own Loan */}
            <Route path={locations.OWN_LOAN_MANAGEMENT.path} element={OwnLoanProcessingPage}/>
            <Route path={locations.OWN_LOAN_HISTORY.path} element={OwnLoanHistoryPage}/>

            <Route path={locations.DYMO_PRINT_LABEL.path} element={DymoPrintLabelPage}/>

            {/* Password */}
            <Route path={locations.FORGOT_PASSWORD.path} element={ForgotPasswordPage}/>
            <Route path={locations.UPDATE_PASSWORD.path} element={UpdatePasswordPage}/>
            <Route path={locations.DASHBOARD.path} element={Dashboard}/>

            {/* User */}
            <Route path={locations.USER_MANAGEMENT.path} element={UserApprovalPage}/>
            <Route path={locations.USER_PROFILE.path} element={UserProfilePage}/>

            {/* Reports */}
            <Route path={locations.REPORTS.path} element={ReportsPage}/>

            {/* Shipping Location */}
            <Route path={locations.SHIPPING_LOCATION_ADD.path} element={ShippingLocationAddPage}/>


            {/* Sad Routes */}
            <Route path="/" element={<Navigate to={locations.LANDING.path} replace/>}/>
            <Route path="/*" element={NotFoundPage}/>
            <Route path="*" element={<Navigate to={locations.LANDING.path} replace/>}/>
        </Routes>
    );
};

export {SiteRoutes};